import { NotFound, MerchantSubmission } from '../index';
import { PARTNER_CONFIG } from '../../config/partnerConfig';

/**
 * This component validates the route based on the partner name.
 * If the partner is valid or no partner is provided (root path), it renders the MerchantSubmission.
 * If the partner is invalid, it renders the NotFound page.
 */
const ValidatePartnerRoute = ({ partner }) => {
  // If the 'partner' prop is not provided (i.e., it's the root path), show the MerchantSubmission.
  if (!partner) {
    return <MerchantSubmission />;
  }

  // Check if the 'partner' exists in PARTNER_CONFIG.
  // If it exists, it's a valid partner, show the MerchantSubmission.
  if (PARTNER_CONFIG[partner]) {
    return <MerchantSubmission />;
  }

  // If the 'partner' prop exists but is not found in PARTNER_CONFIG, show the NotFound page.
  return <NotFound />;
};

export default ValidatePartnerRoute; 